module.exports = __webpack_public_path__ + "static/zh-Hant-1e873bd958cad89706719d020aef207b.png";